export enum SecondhandTaxesLandingPageSection {
  Introduction = 'introduction_section',
  Banner = 'banner_section',
  Facts = 'facts_section',
  Examples = 'examples_section',
  Questions = 'questions_section',
  Tip = 'tip_section',
  Listing = 'listing_section',
  Proof = 'proof_section',
}

export const HELP_CENTER_LINK = '/help/1149'
export const KEEP_SELLING_LINK = '/'
export const NO_CHANGES_TO_TAXES_IMAGE_BASE_URL =
  'https://static-assets.vinted.com/images/landing/no-changes-to-taxes'
